// extracted by mini-css-extract-plugin
module.exports = {"gwCoverageWrapper":"HomeCoverageTable_gwCoverageWrapper__K3JEC","wrapColumnWidth":"HomeCoverageTable_wrapColumnWidth__3qXLd"};